module.exports = __webpack_public_path__ + "themes/fq/font/SignPainter-HouseScript.svg";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/font/SignPainter-HouseScript.svg
// module id = 46
// module chunks = d-game